module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjI0MCIgdmlld0JveD0iMCAwIDI0MCAyNDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+DQo8cGF0aCBkPSJNOTUgNzBMMTIwIDk0TDE0NSA3ME04OCA5OUgxNTJNODggMTIyLjVIMTUyTTEyMCAxNTJWOThNMjAwIDIyMlYzNEMyMDAgMjcuMzcyNiAxOTQuNjI3IDIyIDE4OCAyMkg1MkM0NS4zNzI2IDIyIDQwIDI3LjM3MjYgNDAgMzRWMjIyTDY2LjM1MjkgMTk3LjcwN0w5Mi43MDU5IDIyMkwxMjAgMTk3LjcwN0wxNDcuNzY1IDIyMkwxNzMuODgyIDE5Ny43MDdMMjAwIDIyMloiIHN0cm9rZT0iI0ZGOEYxRCIgc3Ryb2tlLXdpZHRoPSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/05.svg
// module id = Xpc0
// module chunks = 1